import React, { useReducer } from "react";
import Box from "@mui/material/Box";
import ArticlesList from "./ArticlesList";
import ArticleEditor from "./ArticleEditor";
import NavBar from "./NavBar";
import Profile from "./Profile";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Articles, reducer } from "./articleHelpers";

type SignedInProps = {
  signOut: (data?: Record<string | number | symbol, any> | undefined) => void;
  user: any;
  articlesFromDb: Articles;
  profilePictureUrl?: string;
  setProfilePictureUrl: React.Dispatch<string>;
};

const SignedIn: React.FC<SignedInProps> = ({
  signOut,
  user,
  articlesFromDb,
  profilePictureUrl,
  setProfilePictureUrl,
}) => {
  const [articles, dispatch] = useReducer(reducer, articlesFromDb);

  return (
    <Router>
      <Box
        sx={{
          flexGrow: 1,
          bgcolor: "background.paper",
          display: "flex",
        }}
      >
        <NavBar />
        <Box sx={{ ml: 5, mt: 3 }}>
          <Routes>
            <Route path="/">
              <Route index element={<ArticlesList articles={articles} />} />
              <Route
                path="profile"
                element={
                  <Profile
                    signOut={signOut}
                    email={user.attributes.email}
                    name={user.attributes.name}
                    profilePictureUrl={profilePictureUrl}
                    setProfilePictureUrl={setProfilePictureUrl}
                  />
                }
              ></Route>
              {["create-article/:articleId", "edit-article/:articleId"].map(
                (path) => (
                  <Route
                    key={path}
                    path={path}
                    element={
                      <ArticleEditor articles={articles} dispatch={dispatch} />
                    }
                  />
                )
              )}
            </Route>
          </Routes>
        </Box>
      </Box>
    </Router>
  );
};

export default SignedIn;
